import { StageInfo } from '@shared/types/StageInfo';
import { windowWrapper } from '@shared/util/native-wrappers';

export const localStage = 'localhost';
export let PATH_TO_WEBAPP_NGINX = '';
export let PATH_TO_CORE_API = '';
export let PATH_TO_THERAPY_CALENDAR_API = '';
// For calls to externalLogin the same endpoint as in EntraId must be specified.
// Otherwise openIdDict fails to validate the issuer
export let PATH_TO_AUTH_API_EXTERNAL = '';
export let PATH_TO_AUTH_API = '';
export let PATH_TO_SFTP_SERVICE = '';
export let PATH_TO_DEVICE_CONFIGURATION_STORAGE = '';
export let PATH_TO_DEACTIVATED_DEVICE_TRACKER = '';
export let PATH_TO_SD_UPLOADER_API = '';
export let PATH_TO_PATIENT_APP = '';
export let PATH_TO_STATISTICS_GATEWAY = '';
export let PATH_TO_DEVICE_EVENT_STORAGE = '';
export let PATH_TO_QUESTIONNAIRES_API = '';
export let PATH_TO_MOVEMENT_TRACKER = '';
export let PATH_TO_PATIENT_TIMELINE = '';
export let PATH_TO_BUCHAREST = '';
export let PATH_TO_SURVEY_BUILDER = '';
export const getBaseAddress = (): string => {
  // prod_diagnostics runs under today stage.
  if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'prod_diagnostics') {
    return 'prismacloud.com';
  } else {
    return localStage;
  }
};

export const getSurveyUrl = (): string => {
  switch (process.env.NODE_ENV) {
    case 'dev_local': {
      return 'https://localhost:3003/';
    }
    case 'dev_remote': {
      return 'https://suse.prismacloud.today';
    }
    default: {
      return 'https://suse.prismacloud.com';
    }
  }
};

export const query = {
  NOT_PERFORMED: 'NOT_PERFORMED',
  PERFORMED: 'PERFORMED',
} as const;

export const STAGE_NAME = getBaseAddress();
if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'prod_diagnostics') {
  const protocol = window.location.protocol;
  const origin = window.location.origin;
  const baseAddress = getBaseAddress();
  PATH_TO_WEBAPP_NGINX = window.location.origin;
  PATH_TO_CORE_API = `${origin}/api/core`;
  PATH_TO_THERAPY_CALENDAR_API = `${origin}/api/therapy_calendar`;
  PATH_TO_AUTH_API = `${origin}/api/auth2`;
  PATH_TO_AUTH_API_EXTERNAL = `${protocol}//auth2.${baseAddress}`;
  PATH_TO_SFTP_SERVICE = `${origin}/api/sftp`;
  PATH_TO_SD_UPLOADER_API = `${origin}/api/sdupload`;
  PATH_TO_DEVICE_CONFIGURATION_STORAGE = `${origin}/api/configstorage`;
  PATH_TO_DEACTIVATED_DEVICE_TRACKER = `${origin}/api/device_deactivation_tracker`;
  PATH_TO_PATIENT_APP = `${origin}/api/patientapp`;
  PATH_TO_STATISTICS_GATEWAY = `${origin}/api/statisticsgateway`;
  PATH_TO_DEVICE_EVENT_STORAGE = `${origin}/api/eventstorage`;
  PATH_TO_QUESTIONNAIRES_API = `${origin}/api/questionnaires`;
  PATH_TO_MOVEMENT_TRACKER = `${origin}/api/device_movement_tracker`;
  PATH_TO_PATIENT_TIMELINE = `${origin}/api/patient_timeline`;
  PATH_TO_BUCHAREST = `${origin}/api/bucharest`;
  PATH_TO_SURVEY_BUILDER = `${origin}/embedded/builder`;
} else if (process.env.NODE_ENV === 'dev_local' || process.env.NODE_ENV === 'dev_remote') {
  const currentHostname = windowWrapper.location.getHostName();
  const localDomain = `${currentHostname}:3000`;
  PATH_TO_WEBAPP_NGINX = `http://${localDomain}`;
  PATH_TO_CORE_API = `http://${localDomain}/api/core`;
  PATH_TO_THERAPY_CALENDAR_API = `http://${localDomain}/api/therapy_calendar`;
  PATH_TO_AUTH_API = `http://${localDomain}/api/auth2`;
  // for entra ID calls only local development is possible as callback url on remote server will be always server URL
  if (process.env.NODE_ENV === 'dev_local') {
    PATH_TO_AUTH_API_EXTERNAL = 'http://localhost:5202';
  }
  PATH_TO_SFTP_SERVICE = `http://${localDomain}/api/sftp`;
  PATH_TO_SD_UPLOADER_API = `http://${localDomain}/api/sdupload`;
  PATH_TO_DEVICE_CONFIGURATION_STORAGE = `http://${localDomain}/api/configstorage`;
  PATH_TO_DEACTIVATED_DEVICE_TRACKER = `http://${localDomain}/api/device_deactivation_tracker`;
  PATH_TO_PATIENT_APP = `http://${localDomain}/api/patientapp`;
  PATH_TO_STATISTICS_GATEWAY = `http://${localDomain}/api/statisticsgateway`;
  PATH_TO_DEVICE_EVENT_STORAGE = `http://${localDomain}/api/eventstorage`;
  PATH_TO_QUESTIONNAIRES_API = `http://${localDomain}/api/questionnaires`;
  PATH_TO_MOVEMENT_TRACKER = `http://${localDomain}/api/device_movement_tracker`;
  PATH_TO_PATIENT_TIMELINE = `http://${localDomain}/api/patient_timeline`;
  PATH_TO_SURVEY_BUILDER = `${origin}/embedded/builder`;
} else {
  // Used for tests
  const tenant = 'barcelona';
  PATH_TO_WEBAPP_NGINX = window.location.origin;
  PATH_TO_CORE_API = `https://${tenant}.prismacloud.today/api/core`;
  PATH_TO_THERAPY_CALENDAR_API = `https://${tenant}.prismacloud.today/api/therapy_calendar`;
  PATH_TO_AUTH_API = `https://${tenant}.prismacloud.today/api/auth2`;
  PATH_TO_SFTP_SERVICE = `https://${tenant}.prismacloud.today/api/sftp`;
  PATH_TO_SD_UPLOADER_API = `https://${tenant}.prismacloud.today/api/sdupload`;
  PATH_TO_DEVICE_CONFIGURATION_STORAGE = `https://${tenant}.prismacloud.today/api/configstorage`;
  PATH_TO_DEACTIVATED_DEVICE_TRACKER = `https://${tenant}.prismacloud.today/api/device_deactivation_tracker`;
  PATH_TO_PATIENT_APP = `https://${tenant}.prismacloud.today/api/patientapp`;
  PATH_TO_STATISTICS_GATEWAY = `https://${tenant}.prismacloud.today/api/statisticsgateway`;
  PATH_TO_DEVICE_EVENT_STORAGE = `https://${tenant}.prismacloud.today/api/eventstorage`;
  PATH_TO_QUESTIONNAIRES_API = `https://${tenant}.prismacloud.today/api/questionnaires`;
  PATH_TO_MOVEMENT_TRACKER = `https://${tenant}.prismacloud.today/api/device_movement_tracker`;
  PATH_TO_PATIENT_TIMELINE = `https://${tenant}.prismacloud.today/api/patient_timeline`;
  PATH_TO_BUCHAREST = `https://${tenant}.prismacloud.today/api/bucharest`;
  PATH_TO_SURVEY_BUILDER = `https://${tenant}.prismacloud.today/embedded/builder`;
}

/**
 * Base paths of the services that prismaCLOUD considers "external".
 * A 401 from any of these does not mean the prismaCLOUD session has expired, so such
 * responses must not trigger a token refresh or log the user out (see US 75038).
 */
export const getExternalServiceBasePaths = (): string[] => [PATH_TO_PATIENT_APP, PATH_TO_BUCHAREST];

declare global {
  interface Window {
    PATH_TO_CORE_API: string;
    PATH_TO_DEVICE_CONFIGURATION_STORAGE: string;
    PATH_TO_AUTH_API: string;
    PATH_TO_PATIENT_APP: string;
    msCrypto: any;
    GetComplianceType: () => string;
  }
}

// Make constants accessible by UI tests.
window.PATH_TO_CORE_API = PATH_TO_CORE_API;
window.PATH_TO_DEVICE_CONFIGURATION_STORAGE = PATH_TO_DEVICE_CONFIGURATION_STORAGE;
window.PATH_TO_AUTH_API = PATH_TO_AUTH_API;
window.PATH_TO_PATIENT_APP = PATH_TO_PATIENT_APP;

export const USER_IDLE_LIMIT_SECONDS = 3600;
export const CHRONOMETER_TICK_INTERVAL = 30;

export const STATUS_MESSAGE_TYPES = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};

export enum LogoutReason {
  AutotestLogout = 'AutotestLogout',
  LogoutByRequest = 'LogoutByRequest',
  Idle = 'Idle',
  PasswordChange = 'PasswordChange',
  TokenRefreshFailed = 'TokenRefreshFailed',
  Unknown = 'Unknown',
}

export const AuthErrorResponses = {
  secondFactorRequired: 'second_factor_required',
  secondFactorFailed: 'login_twoFactorAuthenticationFailed',
  loginIsLocked: 'login_locked',
  invalidUserOrPassword: 'login_invalidUserOrPassword',
  invalidToken: 'InvalidToken',
  passwordCannotBeSet: 'PasswordCannotBeSet',
  userNotFound: 'UserNotFound',
} as const;

export enum CLAIMS {
  MED_SETTINGS_PERMISSIONS = 'med_settings_permissions',
  USER_OTHER_PERMISSIONS = 'user_other_permissions',
  USER_OTHER_ORGMANAGER_PERMISSIONS = 'user_other_orgmanager_permissions',
  ORG_SETTINGS_PERMISSIONS = 'org_settings_permissions',
  PATIENT_PERMISSIONS = 'patient_permissions',
  ORGANISATION_PERMISSIONS = 'organisation_permissions',
  ORGANISATION_OTHER_PERMISSIONS = 'organisation_other_permissions',
  DEVICES_PERMISSIONS = 'devices_permissions',
  DEACTIVATED_DEVICES = 'deactivated_devices',
  MOVE_DEVICES_BETWEEN_ORGANISATIONS = 'move_devices_between_organisations',
  DEVICE_SETTINGS = 'device_settings',
  SD_CARD_UPLOAD_PERMISSIONS = 'sd_card_upload_permissions',
  DOWNLOAD_FIRMWARE_PERMISSIONS = 'download_firmware_permissions',
  ALL_PICS_PERMISSIONS = 'pic_permissions',
  OWN_PIC_PERMISSIONS = 'pic_self_permissions',
  ORGANISATION_PAIRING_PERMISSIONS = 'organisation_pairing_permissions',
  PREREGISTER_DEVICE = 'preregister_device',
  SHARE_PATIENT = 'share_patient',
  EDIT_PRISMA_SMART_CONFIGURATION = 'edit_prismaSmart_configuration',
  EDIT_PRISMA_LINE_SLEEP_CONFIGURATION = 'edit_prismaLine_sleep_configuration',
  EDIT_PRISMA_LINE_VENTI_CONFIGURATION = 'edit_prismaLine_venti_configuration',
  EDIT_PRISMA_VENT_CONFIGURATION = 'edit_prismaVent_configuration',
  PRISMA_SMART_TELEMONITORING_SWITCHING = 'prismaSmart_telemonitoring_switching',
  QUESTIONNAIRE_TEMPLATES_PERMISSIONS = 'questionnaire_templates',
  PATIENT_QUESTIONNAIRES_PERMISSIONS = 'patient_questionnaires',
  QUESTIONNAIRE_SETTINGS_PERMISSIONS = 'org_questionnaires_settings_permissions',
}

export type PermissionClaims = Record<CLAIMS, PERMISSIONS>;

export enum PERMISSIONS {
  NONE = 0,
  READ = 1,
  EDIT = 2,
  CREATE = 4,
  DELETE = 8,
  All = PERMISSIONS.READ | PERMISSIONS.EDIT | PERMISSIONS.CREATE | PERMISSIONS.DELETE,
}

export const USERS_NUMBER_ON_PAGE = 15;
export const DEVICES_NUMBER_ON_PAGE = 15;
export const PATIENTS_NUMBER_ON_PAGE = 15;
export const SCHEDULED_PATIENTS_NUMBER_ON_PAGE = 5;
export const ORGANISATIONS_NUMBER_ON_PAGE = 15;
export const QUESTIONNAIRES_NUMBER_ON_PAGE = 15;

function isOnStage(...stages: string[]) {
  return stages.indexOf(STAGE_NAME) > -1;
}

export const SENTRY_CONFIG = {
  DSN: 'https://9e2f2c2cdcf344c0bc8343ac90438add@sentry.prismacloud.cc/3',
  IsEnabled: STAGE_NAME !== localStage,
};

export const MATOMO_CONFIG = {
  Url: 'https://matomo.prismacloud.cc',
  SiteId: parseInt('3'),
  IsEnabled: STAGE_NAME !== localStage,
};

export const MUI_LICENSE_KEY =
  '3dd40d72a7bc2e57797db77fd9d76633Tz0xMzI5ODAsRT0xODIxMDUyNzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MixBVD1tdWx0aSxLVj0y';

export const getStageInfo = (): StageInfo => {
  // prod_diagnostics runs under today stage.
  if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'prod_diagnostics') {
    return {
      version: '2.45.0-121517',
      udiCompanyIdentifier: '(01)04050384287272(10)',
      copyright: '© 2016-2026 Löwenstein Medical Technology GmbH + Co. KG',
    };
  } else {
    return {
      version: '1.2.3',
      udiCompanyIdentifier: '(01)04050384287272(10)',
      copyright: '© 2016–2023 Löwenstein Medical Technology GmbH + Co. KG',
    };
  }
};
